import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import {
  Activity,
  Award,
  Users,
  Smile,
  Heart,
  Sun,
  LucideIcon,
} from 'lucide-react'

interface BenefitProps {
  icon: LucideIcon
  title: string
}

const benefits: BenefitProps[] = [
  {
    icon: Activity,
    title: 'Coordenação motora e equilíbrio',
  },
  {
    icon: Award,
    title: 'Disciplina e confiança',
  },
  {
    icon: Users,
    title: 'Socialização e trabalho em equipe',
  },
  {
    icon: Smile,
    title: 'Aprendizado com brincadeiras (lúdico)',
  },
  {
    icon: Heart,
    title: 'Saúde e energia bem direcionada',
  },
  {
    icon: Sun,
    title: 'Rotina ativa longe das telas',
  },
]

export const BenefitsSection = () => {
  return (
    <section id="benefits" className="py-20 bg-white">
      <div className="container px-4 md:px-6 mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-super-text mb-4">
            Por que escolher o{' '}
            <span className="text-super-green">SuperFut Kids</span>?
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Nossa metodologia é focada em criar uma experiência positiva e
            enriquecedora para as crianças.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((item, index) => (
            <Card
              key={index}
              className="border-slate-100 shadow-sm hover:shadow-lg transition-all duration-300 group overflow-hidden"
            >
              <CardHeader className="flex flex-row items-center gap-4 pb-2 space-y-0">
                <div className="w-12 h-12 rounded-2xl bg-blue-50 text-super-blue flex items-center justify-center group-hover:bg-super-blue group-hover:text-white transition-colors duration-300 flex-shrink-0">
                  <item.icon className="w-6 h-6" />
                </div>
                <CardTitle className="text-lg font-bold text-slate-800">
                  {item.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                {/* Content optimized for mobile scanning */}
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}
